import headerBg from '@/assets/images/active/tideng/anniversary/header/header_bg.png';
import headerBg2 from '@/assets/images/active/tideng/anniversary/header/header_bg2.png';
import officeBtn from '@/assets/images/active/tideng/anniversary/header/btn_05.png';
import loginBtn from '@/assets/images/active/tideng/anniversary/header/btn_06.png';
import accountBtn from '@/assets/images/active/tideng/anniversary/header/btn_07.png';
import activeBtn from '@/assets/images/active/tideng/anniversary/header/btn_09.png';
import logoutBtn from '@/assets/images/active/tideng/anniversary/header/btn_10.png';

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg,
    style: ''
  },
  logged_in: {
    background_image: headerBg2,
    main_title_color: '#fff',
    sub_title_color: '#fff',
    tips_color: '#fff',
    game_name: '提灯与地下城'
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: officeBtn,
      style: 'top: 0.22rem',
      link: 'https://tideng.qingcigame.com/leading/'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: 'top: 0.22rem'
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: accountBtn,
      style: 'top: 0.22rem'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: activeBtn,
      style: 'top: 0.22rem',
      link: 'https://qcg.ink/XrLOO4'
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: 'top: 0.22rem'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/tideng/journey/headerConfig.js